import { useMutation } from '@tanstack/react-query';

import { PutMarkerParameters } from '../../../../../../typings/api/skymap/rest/v0/geodata';
import { SkyMapAxiosServiceFactory } from '../../../../services/axios/skymap-axios-service-factory';

export function usePutMarkerMutation() {
  const mutation = useMutation({
    mutationFn: (params: PutMarkerParameters) => {
      return SkyMapAxiosServiceFactory.instance.createGeodataServiceV0().putMarker(params);
    },
    retry: false,
    networkMode: 'always',
  });

  return {
    putMarker: mutation.mutateAsync,
    isPending: mutation.isPending,
  };
}
